export enum ApiUsersCurrentTransactionSource {
  checking = "checking",
  ewa = "ewa",
  flex = "flex",
}

export enum ApiUsersPayrollAccountPayFrequency {
  weekly = "weekly",
  biweekly = "bi_weekly",
  semimonthly = "semi_monthly",
  monthly = "monthly",
}

export enum ApiUsersPayrollAccountCompensationUnit {
  hourly = "hourly",
  daily = "daily",
  weekly = "weekly",
  biweekly = "bi_weekly",
  semimonthly = "semi_monthly",
  monthly = "monthly",
  annually = "annually",
  variable = "variable",
}

export interface ApiUsersPayrollAccount {
  employerName: string;
  compensationAmount: number;
  compensationUnit: ApiUsersPayrollAccountCompensationUnit;
  payFrequency: ApiUsersPayrollAccountPayFrequency;
}

export enum ApiUsersProduct {
  ewaDirect = "ewa_direct",
  ewaFlex = "ewa_flex",
}

export interface ApiUsersProfile {
  name: string;
  firstName: string;
  lastName: string;
  currentTransactionSource: ApiUsersCurrentTransactionSource;
  payrollAccount: ApiUsersPayrollAccount;
  lastFour: string;
  product: ApiUsersProduct;
}
